<template>
  <el-row class="esp-header">
    <el-col :span="12" class="header-left">
      <div class="brand-section">
        <img
          :src="require('@/assets/menu/spread.png')"
          class="menu-icon"
          @click="toggleCollapse"
          alt="Menu"
          :style="{ transform: isCollapsed ? 'rotate(90deg)' : 'rotate(0deg)' }"
        >
        <img src="@/assets/header/logo.png">
      </div>
    </el-col>

    <el-col :span="12" class="header-right">
      <div class="connection-container">
        <el-button class="connection-btn" type="primary" @click="connect" v-if="isConnected == false">
          <div class="dots">
            <span v-for="dot in dots" :key="dot" ></span>{{this.$t("layout_not_connect")}}
            <img :src="require('@/assets/header/Disconnected.png')" class="usb-icon">
          </div>
        </el-button>
        <el-button class="connection-btn" type="primary" @click="disconnect" v-if="isConnected">
          <div class="dots">
            <span v-for="dot in dots" :key="dot" class="online"></span>
            <div class="connected">{{this.$t("layout_connect")}}</div>
            <img :src="require('@/assets/header/Connected.png')" class="usb-icon">
          </div>
        </el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "EspHeader",
  data() {
    return {
      isConnected: false,
      conInfo: '',
      dots: [1],
    }
  },
  mounted() {
    // 监听连接状态变化
    this.$serialPort.on('connection-change', ({isConnected}) => {
      this.isConnected = isConnected;
      this.conInfo = this.$serialPort.getPortInfo();
    });
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    // isConnected: {
    //   type: Boolean,
    //   default: false
    // },
    // conInfo: {
    //   type: Object,
    //   default: () => ({ usbProductId: '' })
    // }
  },
  computed: {
    connectionText() {
      return this.isConnected
        ? `USB ${this.conInfo.usbProductId || ''}`
        : this.$t("layout_connect");
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit('toggle-collapse');
    },
    handleConnection() {
      this.$emit(this.isConnected ? 'disconnect' : 'connect');
    },
    async connect() {
      try {
        await this.$serialPort.connect();
      } catch (error) {
        if (error.name === 'NotFoundError') {
          // User cancelled the port selection
          //this.$message({type: "info", message:"serial port selection cancelled"});
        } else {
          this.$message({type: "error", message: error.message});
          console.error('Connection failed:', error);
        }
      }
    },
    async disconnect() {
      try {
        this.isConnected = false;
        await this.$serialPort.disconnect();
      } catch (error) {
        console.error('Disconnect failed:', error);
      }
    }
  }
}
</script>

<style scoped lang="less">
.esp-header {
  width: 100%;
  height: 100%;
  background-color: #40205B;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;

  .header-left {
    display: flex;
    align-items: center;
    .brand-section {
      display: flex;
      align-items: center;
      height: 100%;

      .menu-icon {
        width: 20px;
        height: 20px;
        margin-left: 35px;
        margin-right: 25px;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover {
          opacity: 0.8;
        }
      }

      .brand-name {
        font-family: 'PingFang SC', sans-serif;
        font-size: 24px;
        font-weight: 500;
        color: #FFFFFF;
        white-space: nowrap;
      }
    }
  }

  .header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .connection-container {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      padding-right: 20px;

      .connection-btn {
        width: 200px;
        height: 50px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          margin-right: 8px;
        }
      }
      .usb-icon {
        width: 20px;
        height: 20px;
        margin-left: 15px;
      }
    }
    .dots {
      display: flex;
      justify-content: center;
      align-items: center; /* 垂直居中 */
      margin: 0 20px;
    }

    .dots span {
      width: 12px; /* 稍微增大圆点 */
      height: 12px;
      background-color: #DDDDDD;
      border-radius: 50%;
      margin: 0 8px; /* 增加圆点间距 */
      transition: all 0.3s ease;
    }
    .dots span.online {
      background-color: #41E285;
    }
    .connected {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #41E285;
      letter-spacing: -0.5px;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/v2/espHeader.vue